/**
 * Rechercher la liste des thèmes parents auxquels à accès un utilisateur
 * @param themes Liste de l'ensemble des thèmes auxquels a accès un utilisateur
 * @returns {array}
 */
export function userParentThemes(themes) {
  let parentThemes = [];

  for (const theme of themes) {
    const rootTheme = getRootThemeWithChildren(theme);
    const parentThemeIndex = parentThemes.findIndex(t => t.id === rootTheme.id);
    if (parentThemeIndex >= 0) {
      // Fusion des thèmes parents identiques
      mergeThemesChildren(parentThemes[parentThemeIndex], rootTheme);
    } else {
      parentThemes.push(rootTheme);
    }
  }

  return parentThemes.sort(sortThemes);
}

export function getRootThemeWithChildren(theme) {
  if (typeof theme.parent === 'undefined' || theme.parent === null) {
    return theme;
  }

  theme.parent.children = [theme];
  return getRootThemeWithChildren(theme.parent);
}

/**
 *
 * @param theme1
 * @param theme2
 * @returns object Theme fusionné
 */
function mergeThemesChildren(theme1, theme2) {
  // On ajoute au theme1 tous les enfants du theme2 qui ne sont pas déjà présents dans theme1
  const theme1Children = Array.isArray(theme1.children) ? theme1.children : [];
  const theme2Children = Array.isArray(theme2.children) ? theme2.children : [];
  theme1.children = [
    ...theme1Children,
    ...theme2Children.filter(t2 => typeof theme1Children.find(t1 => t2.id === t1.id) === 'undefined')
  ].sort(sortThemes);

  // On boucle sur les enfants de theme1 pour les fusionner si nécessaire avec ceux de theme2
  for (let i = 0; i < theme1.children.length; i++) {
    const theme1Child = theme1.children[i];
    const theme2Child = theme2Children.find(t2 => t2.id === theme1Child.id);
    if (theme2Child) {
      mergeThemesChildren(theme1Child, theme2Child);
    }
  }
}

function sortThemes(t1, t2) {
  if (t1.position < t2.position) {
    return -1;
  } else if (t1.position > t2.position) {
    return 1;
  }
  return 0;
}

export default userParentThemes;
